import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { api, formatApiError, FIELD_LABELS } from "@/lib/api";

export default function RenewDialog({ open, onClose, target, onSaved }) {
  const [newDate, setNewDate] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open && target) {
      const due = target.vehicle?.counts?.[target.fieldId]?.due;
      if (due) {
        const d = new Date(`${due}T00:00:00`);
        d.setFullYear(d.getFullYear() + 1);
        setNewDate(d.toISOString().slice(0, 10));
      } else {
        const d = new Date();
        d.setDate(d.getDate() + 365);
        setNewDate(d.toISOString().slice(0, 10));
      }
    }
  }, [open, target]);

  if (!target) return null;
  const label = FIELD_LABELS[target.fieldId];

  const submit = async (e) => {
    e.preventDefault();
    if (!newDate) {
      toast.error("Pick the new due date");
      return;
    }
    setBusy(true);
    try {
      await api.post(`/vehicles/${target.vehicle.id}/renew`, { field: target.fieldId, new_date: newDate });
      toast.success(`${label} renewed — next due ${newDate}`);
      onSaved();
      onClose();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-panel border-line text-hi max-w-sm" data-testid="renew-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-black uppercase tracking-wide">
            Log {label} renewal
          </DialogTitle>
          <DialogDescription className="text-mid text-sm">
            {target.vehicle.plate} — the countdown resets and this lands in the renewal log.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="mt-2 space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="renew-date" className="font-mono text-[10px] uppercase tracking-[0.2em] text-mid">Next {label} due</Label>
            <Input id="renew-date" data-testid="renew-date-input" type="date" value={newDate} onChange={(e) => setNewDate(e.target.value)} />
          </div>
          <button
            type="submit"
            data-testid="renew-save-button"
            disabled={busy}
            className="w-full rounded-full bg-ember py-3 font-display text-lg font-bold uppercase tracking-wider text-ink hover:bg-ember/90 disabled:opacity-40 transition"
          >
            {busy ? "Saving…" : "Log renewal"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
